var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.579102,
    y: 0.0791016,
    width: 21.7895,
    height: 21.7895,
    fill: "url(#pattern0_8477_7949)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_8477_7949",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8477_7949",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_8477_7949",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB9klEQVR4nO3WwW2UQRBE4b44FyBKjkgGC8KBNOxEwEcjPcvS+tLi1k3V/DP9BbB6XaPVbsQYY4wxxhhjLAT4TN0X9x0nj/9uHsE4/rt5BOP4+z4Chws3DhduHC7cOFy4cbhw43DhxuHCjcPFGGOMMcYYY7ixuVgdm4vVsblYHZuL1bG5WB2bi9WxuVgdm4vVdR/Efx6s+/Ps3ANl6l677oMoUvfauQfK1L123QdRpO61cw+UqXvtug+iSN1r5x4oU/fadR9EkbrXzj1Qpu616z6IInWvnXugTN1r130QRepeO/dAmbrXrvsgitS9du6BMnWvXfdBFKl77dwDZepeu+6DKFL32rkHytS9dt0HUaTutXMPlKl77boPokjda+ceKFP32nUfRJG61849UKbutes+iCJ1r517oEzda9d9EEXqXjv3QJm61677IIrUvXbugTJ1r133QRSpe+3cA2XqXrvugyhS99q5B8rUvXbdB1Gk7rVzD5Spe+26D6JI3WvnHihT99p1H0SRutfOPVCm7rXrPogida+de6BM3WsH/GFfv2N1wBP7eozVAQ/s6z5WB3wC/rKfF+BDXAHwg/08xFUAd8Av9vHz7aa4ktsjfL99da/q5fabdq3x//Gb8O3tHwTwzPqeb61fgY/u/cYYY4wxxhixnVdEnFBD7zuCEAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.00ddea429e5c3b05429ae74421751ad6.svg";
export { ForwardRef as ReactComponent };